import consumer from "./consumer";

consumer.subscriptions.create("GlobalNotificationsChannel", {
  connected() {
    console.log("Connected to GlobalNotificationsChannel");
  },

  disconnected() {
    console.log("Disconnected from GlobalNotificationsChannel");
  },

  received(data) {
    console.log("Global notification received");

    const globalStatusDiv = document.getElementById("global-task-generation-status");

    if (globalStatusDiv) {
      if (data.notice == true) {
        globalStatusDiv.textContent = data.message;
        globalStatusDiv.classList.add("block");
      } else {
        globalStatusDiv.textContent = data.message;
        globalStatusDiv.classList.add("block", "failed");
      }

      setTimeout(() => {
        globalStatusDiv.classList.remove("block");
      }, 5000);
    }
  }
});
